import React, { FC } from "react";
import { setClass } from "../../../../../utils";
import '../../../../../styles/components/interval.scss';

interface IntervalProps {
  intervalName: string;
  isSelected: boolean;
}

export const Interval: FC<IntervalProps> = ({ intervalName, isSelected }) => (
  <div className={setClass('interval', isSelected && 'selected')}>{intervalName}</div>
)